// extracted by mini-css-extract-plugin
export var container = "FlowListingItem-module--container--f7dbd";
export var description = "FlowListingItem-module--description--e32e5";
export var image = "FlowListingItem-module--image--e2c21";
export var index = "FlowListingItem-module--index--aabd9";
export var info = "FlowListingItem-module--info--87a0f";
export var list = "FlowListingItem-module--list--603db";
export var listItem = "FlowListingItem-module--listItem--bc0e8";
export var sectionTitle = "FlowListingItem-module--sectionTitle--379be";
export var wrapper = "FlowListingItem-module--wrapper--6a0b7";